export default __webpack_public_path__ + "static/media/addin_preview.ed11965d.png";